module.exports = __webpack_public_path__ + "img/SpectrumPoster - Patterns.2746c603.jpg";